// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ── Navigation ── */
nav {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #1a2b4a; 
  
  padding: 14px 40px;
  position: sticky;
  top: 0;
  z-index: 100;
  box-shadow: 0 2px 8px rgba(0,0,0,0.15);
}

.brand {
  display: flex;
  align-items: center;
  gap: 10px;
  text-decoration: none;
}

/*.brand-logo {
  height: 36px;
  width: auto;
} 
*/
.brand-logo {
  width: 48px;
  height: 48px;
  object-fit: contain;
}

.brand-name {
  color: #ffffff;
  font-size: 1.25rem;
  font-weight: 700;
  letter-spacing: 0.3px;
}

.brand-name span {
  color: #4fc3a1;
}

.nav-list {
  list-style: none;
  display: flex;
  gap: 30px;
  margin: 0;
  padding: 0;
}

.nav-list li a {
  color: #cdd8e8;
  text-decoration: none;
  font-size: 0.95rem;
  font-weight: 500;
  transition: color 0.2s;
}

.nav-list li a:hover {
  color: #4fc3a1;
}

.nav-list li a.signup-btn {
  background-color: #4fc3a1;
  color: #1a2b4a;
  padding: 8px 20px;
  border-radius: 6px;
  font-weight: 700;
  transition: background-color 0.2s, color 0.2s;
}

.nav-list li a.signup-btn:hover {
  background-color: #3aae8c;
  color: #fff;
}

/* Hamburger */
.menu-toggle {
  display: none;
  background: none;
  border: none;
  color: #fff;
  font-size: 1.6rem;
  cursor: pointer;
}

/* Mobile */
@media (max-width: 768px) {
  nav {
    flex-wrap: wrap;
    padding: 14px 20px;
  }

  .menu-toggle {
    display: block;
  }

  .nav-list {
    display: none;
    flex-direction: column;
    width: 100%;
    gap: 0;
    margin-top: 12px;
  }

  .nav-list.active {
    display: flex;
  }

  .nav-list li {
    border-top: 1px solid #2d4266;
  }

  .nav-list li a {
    display: block;
    padding: 12px 4px;
    font-size: 1rem;
  }

  .nav-list li a.signup-btn {
    margin: 8px 0;
    display: inline-block;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Navigation.css"],"names":[],"mappings":"AAAA,qBAAqB;AACrB;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,yBAAyB;;EAEzB,kBAAkB;EAClB,gBAAgB;EAChB,MAAM;EACN,YAAY;EACZ,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,qBAAqB;AACvB;;AAEA;;;;CAIC;AACD;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,SAAS;EACT,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,6CAA6C;AAC/C;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA,cAAc;AACd;EACE,aAAa;EACb,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,eAAe;AACjB;;AAEA,WAAW;AACX;EACE;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,MAAM;IACN,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,cAAc;IACd,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,qBAAqB;EACvB;AACF","sourcesContent":["/* ── Navigation ── */\nnav {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  background-color: #1a2b4a; \n  \n  padding: 14px 40px;\n  position: sticky;\n  top: 0;\n  z-index: 100;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.15);\n}\n\n.brand {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  text-decoration: none;\n}\n\n/*.brand-logo {\n  height: 36px;\n  width: auto;\n} \n*/\n.brand-logo {\n  width: 48px;\n  height: 48px;\n  object-fit: contain;\n}\n\n.brand-name {\n  color: #ffffff;\n  font-size: 1.25rem;\n  font-weight: 700;\n  letter-spacing: 0.3px;\n}\n\n.brand-name span {\n  color: #4fc3a1;\n}\n\n.nav-list {\n  list-style: none;\n  display: flex;\n  gap: 30px;\n  margin: 0;\n  padding: 0;\n}\n\n.nav-list li a {\n  color: #cdd8e8;\n  text-decoration: none;\n  font-size: 0.95rem;\n  font-weight: 500;\n  transition: color 0.2s;\n}\n\n.nav-list li a:hover {\n  color: #4fc3a1;\n}\n\n.nav-list li a.signup-btn {\n  background-color: #4fc3a1;\n  color: #1a2b4a;\n  padding: 8px 20px;\n  border-radius: 6px;\n  font-weight: 700;\n  transition: background-color 0.2s, color 0.2s;\n}\n\n.nav-list li a.signup-btn:hover {\n  background-color: #3aae8c;\n  color: #fff;\n}\n\n/* Hamburger */\n.menu-toggle {\n  display: none;\n  background: none;\n  border: none;\n  color: #fff;\n  font-size: 1.6rem;\n  cursor: pointer;\n}\n\n/* Mobile */\n@media (max-width: 768px) {\n  nav {\n    flex-wrap: wrap;\n    padding: 14px 20px;\n  }\n\n  .menu-toggle {\n    display: block;\n  }\n\n  .nav-list {\n    display: none;\n    flex-direction: column;\n    width: 100%;\n    gap: 0;\n    margin-top: 12px;\n  }\n\n  .nav-list.active {\n    display: flex;\n  }\n\n  .nav-list li {\n    border-top: 1px solid #2d4266;\n  }\n\n  .nav-list li a {\n    display: block;\n    padding: 12px 4px;\n    font-size: 1rem;\n  }\n\n  .nav-list li a.signup-btn {\n    margin: 8px 0;\n    display: inline-block;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
